import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Member Current Coverage Search", -1)
const _hoisted_3 = {
  key: 0,
  class: "bordered-card mt-40"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " You have no Business Associate Agreement (BAA) on file. ", -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex flex-column gap-20 mt-20" }
const _hoisted_7 = { class: "d-flex gap-20 align-items-end flex-md-row flex-column w-100" }
const _hoisted_8 = { class: "custom-select links w-100" }
const _hoisted_9 = { class: "d-flex gap-20 justify-content-between w-100 mt-30 mb-30" }
const _hoisted_10 = { class: "d-flex gap-20" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  class: "small striped toggle no-underline mt-30",
  id: "table-contract-info"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "NBF ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Current Coverage"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Coverage "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("small", null, " (Effective Date - Term Date) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "Bad Address "),
    /*#__PURE__*/_createElementVNode("th", null, "Upcoming Coverage "),
    /*#__PURE__*/_createElementVNode("th", null, "Plan C Balance "),
    /*#__PURE__*/_createElementVNode("th", null, "Plan A Days")
  ])
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, " - ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, " - ", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "text-center"
  }, " No records found")
], -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      "m:errors": "errors",
      success: _ctx.success
    }, null, 8, ["success"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: "This page allows you to look for current coverage for your Member(s).",
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }),
      (!$setup.loadingSearch && !$setup.hasBAAOnFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", {
              innerHTML: $setup.localStore.getBAAMessage()
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      ($setup.hasBAAOnFile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Multiselect, {
                    modelValue: $setup.filters.PlanType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.PlanType) = $event)),
                    options: $setup.planTypes,
                    placeholder: "Type to search",
                    multiple: true,
                    "hide-selected": true,
                    searchable: true,
                    "close-on-select": true,
                    onSelect: $setup.handleTypeChange,
                    label: "description",
                    "track-by": "code"
                  }, null, 8, ["modelValue", "options", "onSelect"])
                ]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  name: "number",
                  placeholder: "Add Member’s NBF ID/SSN",
                  max: 25,
                  modelValue: $setup.filters.ParticipantID,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.ParticipantID) = $event)),
                  customClass: "w-100"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  placeholder: "Add Member’s First Name",
                  max: 25,
                  modelValue: $setup.filters.FirstName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.FirstName) = $event)),
                  customClass: "w-100"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  placeholder: "Add Member’s Last Name",
                  max: 25,
                  modelValue: $setup.filters.LastName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.LastName) = $event)),
                  customClass: "w-100"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary w-sm-100",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.resetFilters && $setup.resetFilters(...args)), ["prevent"]))
                  }, "Clear Filters"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary w-sm-100 plan-modal",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.printList && $setup.printList(...args)), ["prevent"])),
                    disabled: $setup.loadingSearch || $setup.downloading || !$setup.coverageList.length
                  }, _toDisplayString($setup.downloading ? 'Printing...' : 'Print List'), 9, _hoisted_11)
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary w-sm-100",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["prevent"])),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["enter"]))
                }, _toDisplayString($setup.loadingSearch ? 'Searching...' : 'Search'), 33)
              ])
            ]),
            ($setup.loadingSearch)
              ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("table", _hoisted_13, [
                    _hoisted_14,
                    ($setup.coverageList.length)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coverageList, (person) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: person.PersonID,
                              class: "large"
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("a", {
                                  href: "javascript;",
                                  class: "plan-modal",
                                  onClick: _withModifiers(($event: any) => ($setup.openModal('local-member-profile', 'Member Profile', 'plan-profile plan-tables profile', null, { PersonID: person.PersonID })), ["prevent"])
                                }, _toDisplayString(person.PersonID), 9, _hoisted_16)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(person.FullName), 1),
                              _createElementVNode("td", null, _toDisplayString(person.Plan), 1),
                              _createElementVNode("td", null, _toDisplayString(person.Coverage), 1),
                              _createElementVNode("td", null, _toDisplayString(person.BadAddress), 1),
                              _hoisted_17,
                              _hoisted_18
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_19, _hoisted_21))
                  ]),
                  _createVNode(_component_PaginationComponent, {
                    paginator: $setup.paginator,
                    onFetchData: $setup.fetchPaginationData
                  }, null, 8, ["paginator", "onFetchData"])
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}